import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    changePassword: translate({ id: 'settings.rmAccount.view.changePasswordModal.controls.send' }),
    cancel: translate({ id: 'settings.rmAccount.view.changePasswordModal.controls.cancel' }),

    changePasswordSuccess: translate({
      id: 'settings.rmAccount.view.changePasswordModal.toast.success',
    }),
    changePasswordGenericError: translate({
      id: 'settings.rmAccount.view.changePasswordModal.toast.genericError',
    }),
    changePasswordWrongOldPasswordError: translate({
      id: 'settings.rmAccount.view.changePasswordModal.toast.wrongOldPasswordError',
    }),
  }))

  return api
}
